(function () {
  const DEFAULT_BRAND_TOKEN = '71d16ff6-6853-11ee-981a-0242ac110002';

  function parsePrice(text) {
    if (!text) return 0;

    const cleaned = String(text).replace(/[^\d.]/g, '');
    const value = parseFloat(cleaned);

    return Number.isFinite(value) ? value : 0;
  }

  function formatPrice(value) {
    const amount = Number.isFinite(value) ? value : 0;
    return `$${amount.toFixed(2)}`;
  }

  function getQty(wrapper) {
    const qtyInput = wrapper.querySelector('[data-bnx-qty-input]');
    let qty = parseInt(qtyInput?.value, 10);

    if (!Number.isFinite(qty) || qty < 1) {
      qty = 1;
    }

    if (qtyInput) {
      qtyInput.value = qty;
    }

    return qty;
  }

  function getBasePrice(wrapper) {
    const baseEl = wrapper.querySelector('[data-bnx-base-price]');
    const storedBasePrice = parseFloat(wrapper.dataset.basePrice);

    if (Number.isFinite(storedBasePrice) && storedBasePrice > 0) {
      return storedBasePrice;
    }

    const injectedPrice = parsePrice(baseEl?.innerText || baseEl?.textContent);

    if (injectedPrice > 0) {
      wrapper.dataset.basePrice = injectedPrice;
    }

    return injectedPrice;
  }

  function updateSingleBNXPrice(wrapper) {
    const priceEl = wrapper.querySelector('[data-bnx-dynamic-price]');
    const basePrice = getBasePrice(wrapper);
    const qty = getQty(wrapper);

    if (!priceEl || basePrice <= 0) return;

    priceEl.innerText = formatPrice(basePrice * qty);
  }

  function getEngravingLines(wrapper) {
    const engravingFields = wrapper.querySelector('[data-bnx-engraving-fields]');
    const isVisible = engravingFields && engravingFields.style.display !== 'none';

    if (!isVisible) return null;

    const lines = Array.from(wrapper.querySelectorAll('[data-bnx-engraving-line]'))
      .map((input) => input.value.trim())
      .filter(Boolean);

    return lines.length ? lines.join('\n') : null;
  }

  function waitForBasePrice(wrapper, attempts) {
    attempts = attempts || 0;

    const basePrice = getBasePrice(wrapper);

    if (basePrice > 0 || attempts >= 30) {
      updateSingleBNXPrice(wrapper);
      return;
    }

    setTimeout(function () {
      waitForBasePrice(wrapper, attempts + 1);
    }, 200);
  }

  function setButtonState(button, label, disabled) {
    if (!button) return;

    button.textContent = label;
    button.disabled = !!disabled;
  }

  function addSingleProductToCart(wrapper, button) {
    const productId = parseInt(wrapper.dataset.bnxProductId, 10);
    const brandToken = wrapper.dataset.brandToken || DEFAULT_BRAND_TOKEN;
    const qty = getQty(wrapper);
    const engraving = getEngravingLines(wrapper);
    const originalText = button.dataset.originalText || button.textContent.trim() || 'Add to Cart';

    if (!productId) {
      console.error('[BNX Single] Missing or invalid Bottle Nexus product ID.', wrapper.dataset.bnxProductId);
      alert('This product is not configured correctly. Missing Bottle Nexus product ID.');
      return;
    }

    if (!window.bottlenexus || typeof window.bottlenexus.addToCart !== 'function') {
      console.error('[BNX Single] window.bottlenexus.addToCart is not available.');
      alert('Cart is still loading. Please try again in a moment.');
      return;
    }

    setButtonState(button, 'Adding...', true);

    try {
      const result = window.bottlenexus.addToCart(productId, brandToken, {
        quantity: qty,
        recurrence: 'one-time',
        donation: 'enforce',
        engravingLines: engraving
      });

      Promise.resolve(result)
        .then(function () {
          setButtonState(button, 'Added!', true);

          setTimeout(function () {
            setButtonState(button, originalText, false);
          }, 1500);
        })
        .catch(function (error) {
          console.error('[BNX Single] Add to cart failed:', error);
          setButtonState(button, originalText, false);
          alert('Unable to add this product to cart. Please try again.');
        });
    } catch (error) {
      console.error('[BNX Single] Add to cart failed:', error);
      setButtonState(button, originalText, false);
      alert('Unable to add this product to cart. Please try again.');
    }
  }

  function initializeSingleBNXWrapper(wrapper) {
    if (!wrapper || wrapper.dataset.customJsInitialized === 'true') return;

    wrapper.dataset.customJsInitialized = 'true';

    const engravingToggle = wrapper.querySelector('[data-bnx-toggle-engraving]');
    const engravingFields = wrapper.querySelector('[data-bnx-engraving-fields]');
    const qtyInput = wrapper.querySelector('[data-bnx-qty-input]');
    const qtyButtons = wrapper.querySelectorAll('[data-bnx-qty-change]');
    const addButton = wrapper.querySelector('[data-bnx-single-add-to-cart]');

    if (addButton) {
      addButton.dataset.originalText = addButton.textContent.trim() || 'Add to Cart';
    }

    if (engravingToggle && engravingFields) {
      engravingToggle.addEventListener('click', function () {
        const isCurrentlyHidden = engravingFields.style.display === 'none' || getComputedStyle(engravingFields).display === 'none';

        engravingFields.style.display = isCurrentlyHidden ? 'block' : 'none';

        wrapper.dataset.personalizationAdded = isCurrentlyHidden ? 'true' : 'false';

        updateSingleBNXPrice(wrapper);
      });
    }

    qtyButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        const delta = parseInt(button.dataset.bnxQtyChange, 10) || 0;
        const currentQty = getQty(wrapper);

        if (qtyInput) {
          qtyInput.value = Math.max(1, currentQty + delta);
        }

        updateSingleBNXPrice(wrapper);
      });
    });

    if (qtyInput) {
      qtyInput.addEventListener('change', function () {
        getQty(wrapper);
        updateSingleBNXPrice(wrapper);
      });

      qtyInput.addEventListener('input', function () {
        updateSingleBNXPrice(wrapper);
      });
    }

    if (addButton) {
      addButton.addEventListener('click', function () {
        addSingleProductToCart(wrapper, addButton);
      });
    }

    waitForBasePrice(wrapper);
  }

  function initializeAllSingleBNXWrappers() {
    document.querySelectorAll('[data-bnx-single-wrapper]').forEach(function (wrapper) {
      initializeSingleBNXWrapper(wrapper);
    });
  }

  document.addEventListener('DOMContentLoaded', initializeAllSingleBNXWrappers);

  document.addEventListener('shopify:section:load', function () {
    initializeAllSingleBNXWrappers();
  });
})();